import React from 'react';

import classes from './ServicesWrap.module.pcss';



const ServicesWrap = props => (
    <div className={classes.ServicesWrap}>
        {props?.children}
    </div>
);

export default ServicesWrap;
